export const GameEvents = {
  PlayerHealthChanged: "player-health-changed",
  PlayerManaChanged: "player-mana-changed",
  BossHealthChanged: "boss-health-changed",
  SpellRecognized: "spell-recognized",
  SpellCooldownChanged: "spell-cooldown-changed",
  SpellRejected: "spell-rejected",
  EnemyDefeated: "enemy-defeated",
  BossDefeated: "boss-defeated",
  PlayerDefeated: "player-defeated",
} as const;
